import * as React from "react";
import { forwardRef } from "react";
const SvgStakes = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 15V11M3 15H6M3 15H1M3 11V2.5C3 1.78642 3.72593 1.30247 4.38462 1.57692L12.7846 5.07692C13.6051 5.4188 13.6051 6.5812 12.7846 6.92308L3 11Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgStakes);
export default ForwardRef;
